import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'
import Nprogress from 'nprogress';
import qs from 'qs'
import router from '@/router/index'

Vue.use(Vuex)
const state = {
  inventoryDashboardDetails: [],
  inventoryActivityDetails: [],
  inventoryItemTrackDetails: [],
  inventoryStockDetails: [],
  inventoryStockDetailsTable: [],
  inventoryItemCategoryDetails: [],
  itemSampleFilePath: '',
  vendorManagementDetails: [],
  vendorManagementTableDetails: [],
  vendorSampleFilePath: '',
  locationManagementDetails: [],
  locationSampleFilePath: '',
  locationManagementTableDetails: [],
  inventoryApprovalDetails: [],
  inventoryApprovalTableDetails: [],
  inventoryConfigurationDetails: [],
  inventoryStockOverviewDetails: [],
  inventoryStockOverviewTableDetails: [],
  add_item: [],
  add_vendor: [],
  stockItemSampleFilePath: '',
  transferredItemsPercent: "",
  deleteStockItemPercent: "",
  inventoryStockAddPercent:""
}

const mutations = {
  SET_INVENTORY_DASHBORD_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.inventoryDashboardDetails = new Array();
    if (parseData != null) {
      tData['inventoryDashboardDetails'] = parseData;
      state.inventoryDashboardDetails = tData;
    }
  },
  SET_INVENTORY_ACTIVITY_TABLE_LIST(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.inventoryActivityDetails = new Array();
    if (parseData != null) {
      tData['inventoryActivityDetails'] = parseData;
      state.inventoryActivityDetails = tData;
    }
  },
  SET_INVENTORY_ITEM_TRACK_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.inventoryItemTrackDetails = new Array();
    if (parseData != null) {
      tData['inventoryItemTrackDetails'] = parseData;
      state.inventoryItemTrackDetails = tData;
    }
  },
  SET_INVENTORY_STOCK_DETAILS_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.inventoryStockDetails = new Array();
    if (parseData != null) {
      tData['inventoryStockDetails'] = parseData;
      state.inventoryStockDetails = tData;
    }
  },
  SET_INVENTORY_STOCK_DETAILS_TABLE_DATA(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.inventoryStockDetailsTable = new Array();
    if (parseData != null) {
      tData['inventoryStockList'] = parseData;
      state.inventoryStockDetailsTable = tData;
    }
  },
  UPDATE_INVENTORY_STOCK_DETAILS_TABLE_DATA(state, data) {
    var id = data.id;
    var accountId = data.accountId;
    if (Object.keys(state.inventoryStockDetailsTable).length != 0) {
      var index = state.inventoryStockDetailsTable["inventoryStockList"].findIndex(stock => stock.inventory_item_transfers.id == id);
      state.inventoryStockDetailsTable["inventoryStockList"][index].inventory_item_transfers.status = "received";
    }
  },
  UPDATE_QUALITY_INVENTORY_STOCK_DETAILS_TABLE_DATA(state, data) {
    var id = data.id;
    var quality = data.quality;
    if (Object.keys(state.inventoryStockDetailsTable).length != 0) {
      var index = state.inventoryStockDetailsTable["inventoryStockList"].findIndex(stock => stock.inventory_item_transfers.id == id);
      state.inventoryStockDetailsTable["inventoryStockList"][index].inventory_item_transfers.quality = quality;
    }
  },
  UPDATE_MAC_INVENTORY_STOCK_DETAILS_TABLE_DATA(state, data) {
    var id = data.id;
    var mac = data.mac;
    if (Object.keys(state.inventoryStockDetailsTable).length != 0) {
      var index = state.inventoryStockDetailsTable["inventoryStockList"].findIndex(stock => stock.inventory_item_transfers.id == id);
      state.inventoryStockDetailsTable["inventoryStockList"][index].inventory_item_transfers.item_mac = mac;
    }
  },
  SET_INVENTORY_ITEM_CATEGORY_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.inventoryItemCategoryDetails = new Array();
    state.itemSampleFilePath = parseData.samplePath;
    if (parseData != null) {
      tData['inventoryItemCategoryDetails'] = parseData;
      state.inventoryItemCategoryDetails = tData;
    }
  },
  UPDATE_INVENTORY_ITEM_CATEGORY_DATA(state, data) {
    var id = data.id;
    var name = data.name;
    if (Object.keys(state.inventoryItemCategoryDetails).length != 0) {
      var index = state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].itemCategories.findIndex(item => item.InventoryItemCategory.id == id);
      state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].itemCategories[index].InventoryItemCategory.name = name;
    }
  },
  DELETE_INVENTORY_ITEM_CATEGORY_DATA(state, data) {
    var id = data.id;
    var name = data.name;
    if (Object.keys(state.inventoryItemCategoryDetails).length != 0) {
      var index = state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].itemCategories.findIndex(item => item.InventoryItemCategory.id == id);
      state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].itemCategories.splice(index, 1);
    }
  },
  UPDATE_INVENTORY_ITEM_DATA(state, data) {
    var id = data.id;

    if (Object.keys(state.inventoryItemCategoryDetails).length != 0) {
      var index = state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].items.findIndex(item => item.InventoryItem.id == id);
      state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].items[index].InventoryItem.name = data.itemName;
      state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].items[index].InventoryItem.brand = data.itemBrand;
      state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].items[index].InventoryItem.code = data.itemCode;
      state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].items[index].InventoryItem.min_stock = data.minStock;
      state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].items[index].InventoryItem.price = data.itemPrice;
      state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].items[index].InventoryItem.type = data.itemType;
      state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].items[index].InventoryItem.unit_of_measure = data.unitOfMeasure;
      state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].items[index].InventoryItem.warranty = data.warranty;
    }
  },
  DELETE_INVENTORY_ITEM_DATA(state, data) {
    var id = data.id;
    if (Object.keys(state.inventoryItemCategoryDetails).length != 0) {
      var index = state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].items.findIndex(item => item.InventoryItem.id == id);
      state.inventoryItemCategoryDetails["inventoryItemCategoryDetails"].items.splice(index, 1);
    }
  },
  SET_VENDOR_MANAGEMENT_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.vendorSampleFilePath = parseData.samplePath;
    state.vendorManagementDetails = new Array();
    if (parseData != null) {
      tData['vendorDetails'] = parseData;
      state.vendorManagementDetails = tData;
    }
  },
  SET_VENDOR_MANAGEMENT_TABLE_DATA(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.vendorManagementTableDetails = new Array();
    if (parseData != null) {
      tData['vendorLists'] = parseData;
      state.vendorManagementTableDetails = tData;
    }
  },
  EDIT_VENDOR_TABLE_DATA(state, data) {
    var id = data.vendorId;
    if (Object.keys(state.vendorManagementTableDetails).length != 0) {
      var index = state.vendorManagementTableDetails["vendorLists"].findIndex(vendor => vendor.VendorManagement.id == id);
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.name = data.vendorName;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.mobile = data.phone;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.landline = data.landline;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.email = data.email;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.currency = data.currency;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.country = data.country;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.contact_person = data.contactPerson;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.company_name = data.companyName;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.code = data.vendorCode;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.address_state = data.address_state;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.address_pin = data.address_pin;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.address_line2 = data.address_line2;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.address_line1 = data.address_line1;
      state.vendorManagementTableDetails["vendorLists"][index].VendorManagement.address_city = data.address_city;
    }
  },
  DELETE_VENDOR_DATA(state, data) {
    var id = data.id;
    if (Object.keys(state.vendorManagementTableDetails).length != 0) {
      var index = state.vendorManagementTableDetails["vendorLists"].findIndex(vendor => vendor.VendorManagement.id == id);
      state.vendorManagementTableDetails["vendorLists"].splice(index, 1);
    }
  },
  SET_LOCATION_MANAGEMENT_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.locationSampleFilePath = parseData.samplePath;
    state.locationManagementDetails = new Array();
    if (parseData != null) {
      tData['locationDetails'] = parseData;
      state.locationManagementDetails = tData;
    }
  },
  SET_LOCATION_MANAGEMENT_TABLE_DATA(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.locationManagementTableDetails = new Array();
    if (parseData != null) {
      tData['locationLists'] = parseData;
      state.locationManagementTableDetails = tData;
    }
  },
  DELETE_LOCATION_DATA(state, data) {
    var id = data.id;
    if (Object.keys(state.locationManagementTableDetails).length != 0) {
      var index = state.locationManagementTableDetails["locationLists"].findIndex(loc => loc.AccountLocation.id == id);
      state.locationManagementTableDetails["locationLists"].splice(index, 1);
    }
  },
  SET_INVENTORY_APPROVAL_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.inventoryApprovalDetails = new Array();
    if (parseData != null) {
      tData['approveDetails'] = parseData;
      state.inventoryApprovalDetails = tData;
    }
  },
  SET_IVENTORY_APPROVAL_TABLE_DATA(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.inventoryApprovalTableDetails = new Array();
    if (parseData != null) {
      tData['approveLists'] = parseData;
      state.inventoryApprovalTableDetails = tData;
    }
  },
  APPROVE_IVENTORY_APPROVAL_TABLE_DATA(state, data) {
    var id = data.id;
    var accId = data.accId;
    if (Object.keys(state.inventoryApprovalTableDetails).length != 0) {
      var index = state.inventoryApprovalTableDetails["approveLists"].findIndex(item => item.InventoryLeadApproval.id == id && item.InventoryLeadApproval.account_id == accId);
      state.inventoryApprovalTableDetails["approveLists"].splice(index, 1);
    }
  },
  SET_INVENTORY_CONFIGURATION_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.inventoryConfigurationDetails = new Array();
    if (parseData != null) {
      tData['inventoryConfigurationDetails'] = parseData;
      state.inventoryConfigurationDetails = tData;
    }
  },
  DELETE_ADMIN_CONFIGURE_DATA(state, data) {
    var id = data.id;
    if (Object.keys(state.inventoryConfigurationDetails).length != 0) {
      var index = state.inventoryConfigurationDetails["inventoryConfigurationDetails"].configs.findIndex(item => item.Admin.id == id);
      state.inventoryConfigurationDetails["inventoryConfigurationDetails"].configs.splice(index, 1);
    }
  },
  DELETE_ADMIN_CLASSIFICATION_ALL_DATA(state, data) {
    var id = data.id;
    if (Object.keys(state.inventoryConfigurationDetails).length != 0) {
      var index = state.inventoryConfigurationDetails["inventoryConfigurationDetails"].adminToassignedAllLevels.findIndex(item => item.id == id);
      state.inventoryConfigurationDetails["inventoryConfigurationDetails"].adminToassignedAllLevels.splice(index, 1);
    }
  },
  DELETE_ADMIN_CLASSIFICATION_UNASSIGNED_DATA(state, data) {
    var id = data.id;
    if (Object.keys(state.inventoryConfigurationDetails).length != 0) {
      var index = state.inventoryConfigurationDetails["inventoryConfigurationDetails"].adminToUnassignedLevels.findIndex(item => item.id == id);
      state.inventoryConfigurationDetails["inventoryConfigurationDetails"].adminToUnassignedLevels.splice(index, 1);
    }
  },
  SET_CHECKBOX_VALUE(state, settingsData) {
    if (settingsData.type == 'inventory') {
      if (settingsData.switchCheckBoxValue == 'on') {
        Vue.set(state.inventoryConfigurationDetails["inventoryConfigurationDetails"], 'subAccountsCanNotChangeInventoryConfiguration', 'Yes');
      } else {
        Vue.set(state.inventoryConfigurationDetails["inventoryConfigurationDetails"], 'subAccountsCanNotChangeInventoryConfiguration', 'No');
      }
    }
  },
  SET_INVENTORY_STOCK_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.stockItemSampleFilePath = parseData.samplePath;
    state.inventoryStockOverviewDetails = new Array();
    if (parseData != null) {
      tData['inventoryStockDetails'] = parseData;
      state.inventoryStockOverviewDetails = tData;
    }
  },
  SET_IVENTORY_STOCK_TABLE_DATA(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.inventoryStockOverviewTableDetails = new Array();
    if (parseData != null) {
      tData['inventoryStockList'] = parseData;
      state.inventoryStockOverviewTableDetails = tData;
    }
  },
  DELETE_STOCK_ITEM_DATA(state, data) {
    var id = data.id;
    if (Object.keys(state.inventoryStockOverviewTableDetails).length != 0) {
      var index = state.inventoryStockOverviewTableDetails["inventoryStockList"].findIndex(item => item.InventoryItemDetail.id == id);
      state.inventoryStockOverviewTableDetails["inventoryStockList"].splice(index, 1);
    }
  },
  ADD_ITEM(state, data) {
    state.add_item = data;
  },
  ADD_VENDOR(state, data) {
    state.add_vendor = data;
  },
  CLEAR_STOCK_DETAIL_STATE(state) {
    state.inventoryDashboardDetails = [];
    state.inventoryActivityDetails = [];
    state.inventoryItemTrackDetails = [];
    state.inventoryStockDetails = [];
    state.inventoryStockDetailsTable = [];
    state.inventoryItemCategoryDetails = [];
    state.itemSampleFilePath = '';
    state.vendorManagementDetails = [];
    state.vendorManagementTableDetails = [];
    state.vendorSampleFilePath = '';
    state.locationManagementDetails = [];
    state.locationSampleFilePath = '';
    state.locationManagementTableDetails = [];
    state.inventoryApprovalDetails = [];
    state.inventoryApprovalTableDetails = [];
    state.inventoryConfigurationDetails = [];
    state.inventoryStockOverviewDetails = [];
    state.inventoryStockOverviewTableDetails = [];
    state.add_item = [];
    state.add_vendor = [];
    state.stockItemSampleFilePath = '';
  },
  // SOCKET_TRANSFERREDITEMSPERCENTAGE(state, data) {
  //   state.transferredItemsPercent = data;
  // },
  // SOCKET_DELETESTOCKDETAILPERCENTAGE(state, data) {
  //   state.deleteStockItemPercent = data;
  // },
  // SOCKET_INVENTORYSTOCKADDPERCENTAGE(state, data) {
  //   state.inventoryStockAddPercent = data;
  // },

}

const actions = {
  submitTransferItemsAll({
    commit,
    dispatch
  }, postData) {
      return new Promise((resolve, reject) => {
          //Nprogress.start()
          let loader = Vue.$loading.show({
              canCancel: false,
          });
          
          axios.post('/inventory/transfer_items_all', postData, {
              headers: { 'Content-Type': 'multipart/form-data' }
          })
              .then(response => {
                  loader.hide()
                  if (response.data.status != 'success') {
                      reject(response.data.message);
                      return;
                  }
                  
                  resolve(response.data);

              })
              .catch(error => console.log(error));
      });
  },
  clearStockDetailState({
    commit,
    dispatch
  }) {
    commit('CLEAR_STOCK_DETAIL_STATE')
  },
  fetchInventoryDashboardList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {

      axios.get('/inventory/inventory_dashboard/' + postData.timeRange + '/' + postData.account + '/true')
        .then(response => {
          Nprogress.done()
          commit("SET_INVENTORY_DASHBORD_DATA", response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchInventoryActivityList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/inventory/inventory_log_data', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          commit('SET_INVENTORY_ACTIVITY_TABLE_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  getInventoryGraphData({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/inventory/get_inventory_graph', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchInventoryDashboardTrackItemList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/inventory/track_item', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchInventoryItemTrackDetail({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/inventory/inventory_item_track_detail', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchInventoryItemTrackList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {

      axios.get('/inventory/inventory_item_track/' + postData.accountId + '/' + postData.trackSerial + '/true')
        .then(response => {
          Nprogress.done()
          commit("SET_INVENTORY_ITEM_TRACK_DATA", response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchInventoryStockDetailList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {

      axios.get('/inventory/goods_in_use/true')
        .then(response => {
          Nprogress.done()
          commit("SET_INVENTORY_STOCK_DETAILS_DATA", response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchInventoryStockDetailTableList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/inventory/track_item_details_data', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          commit("SET_INVENTORY_STOCK_DETAILS_TABLE_DATA", res.data);
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  returnToStockModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/item_return_to_stock', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  changeItemStatusModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/change_item_status', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              accountId: postData.accountId,
              id: postData.itemTranId,
            }
            commit('UPDATE_INVENTORY_STOCK_DETAILS_TABLE_DATA', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  changeItemQualityModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/change_goods_quality', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              quality: postData.itemQuality,
              id: postData.itemTranId,
            }
            commit('UPDATE_QUALITY_INVENTORY_STOCK_DETAILS_TABLE_DATA', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  changeItemMACModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/change_goods_mac', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              mac: postData.trackMacMac,
              id: postData.itemTranId,
            }
            commit('UPDATE_MAC_INVENTORY_STOCK_DETAILS_TABLE_DATA', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error))
    });
  },

  getSelectedInventoryItemDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/get_selected_items_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.message != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },

  getInventoryItemDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/get_item_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.message != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchInventoryItemCategoryDetails({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {

      axios.get('/inventory/inventory_items/true')
        .then(response => {
          Nprogress.done()
          if (response.data.status == "redirect") {
            router.push(response.data.message);
          } else {
            commit("SET_INVENTORY_ITEM_CATEGORY_DATA", response.data);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  createItemCategoryModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/create_item_category', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.inputItemCategoryId,
              name: postData.itemCategoryName,
            }
            if (postData.addEditType == "edit") {
              commit('UPDATE_INVENTORY_ITEM_CATEGORY_DATA', successData);
            }
            resolve(response.data);
          }

        })
        .catch(error => console.log(error))
    });
  },
  deleteItemCategoryModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/delete_item_category', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.deleteItemId,
              name: postData.deleteItemCategoryName,
            }
            commit('DELETE_INVENTORY_ITEM_CATEGORY_DATA', successData);
            resolve(response.data);
          }

        })
        .catch(error => console.log(error))
    });
  },
  createItemModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/create_item', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.itemId,
              itemName: postData.itemName,
              itemBrand: postData.itemBrand,
              itemCode: postData.itemCode,
              unitOfMeasure: postData.unitOfMeasure,
              warranty: postData.warranty,
              itemType: postData.itemType,
              itemPrice: postData.itemPrice,
              minStock: postData.minStock,
            }
            if (postData.addEditType == "edit") {
              commit('UPDATE_INVENTORY_ITEM_DATA', successData);
            }
            commit("ADD_ITEM", response.data.data);
            resolve(response.data);
          }

        })
        .catch(error => console.log(error))
    });
  },
  deleteItemModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/delete_item', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.itemId,
            }
            commit('DELETE_INVENTORY_ITEM_DATA', successData);
            resolve(response.data);
          }

        })
        .catch(error => console.log(error))
    });
  },
  fetchInventoryRequestItems({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {

      axios.post('/inventory/inventory_request_items')
        .then(response => {
          Nprogress.done()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getInventoryCategories({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/get_inventory_categories', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  submitRequestItemForm({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/raise_request_inventory', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importItemModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/import_inventory_item_file', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importItemCopy({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/import_inventory_item_file_copy', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchVendorManagementDetail({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {

      axios.get('/inventory/vendor_management/true')
        .then(response => {
          Nprogress.done()
          commit("SET_VENDOR_MANAGEMENT_DATA", response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchVendorManagementTableList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/inventory/vendor_management_data', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit("SET_VENDOR_MANAGEMENT_TABLE_DATA", res.data);
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  addVendorSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/vendor_management', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            if (postData.type == "edit") {
              commit('EDIT_VENDOR_TABLE_DATA', postData);
            }
            commit("ADD_VENDOR", response.data.data);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  deleteVendorModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/delete_vendor', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.vendorId,
            }
            commit('DELETE_VENDOR_DATA', successData);
            resolve(response.data);
          }

        })
        .catch(error => console.log(error))
    });
  },
  importVendorModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/import_inventory_vendor_file', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importVendorCopy({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/import_inventory_vendor_file_copy', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchlocationManagementDetail({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {

      axios.get('/inventory/manage_locations/true')
        .then(response => {
          Nprogress.done()
          commit("SET_LOCATION_MANAGEMENT_DATA", response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchlocationManagementTableList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/inventory/manage_locations_data', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit("SET_LOCATION_MANAGEMENT_TABLE_DATA", res.data);
          }
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchlocationDetailsList({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/get_location_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchVendorDetailsList({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/get_vendor_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteLocationModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/delete_location', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.locationId,
            }
            commit('DELETE_LOCATION_DATA', successData);
            resolve(response.data);
          }

        })
        .catch(error => console.log(error))
    });
  },
  importLocationModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/import_inventory_location_file', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importLocationCopy({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/import_inventory_location_file_copy', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchInventoryApprovalDetailList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {

      axios.get('/inventory/inventory_approval/' + true)
        .then(response => {
          Nprogress.done()
          commit("SET_INVENTORY_APPROVAL_DATA", response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchInventoryApprovalTableList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/inventory/get_all_inventory_approvals', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          commit("SET_IVENTORY_APPROVAL_TABLE_DATA", res.data);
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  getInventoryItemDetail({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/get_inventory_item_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  approveItemModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/approve_inventory_approval', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.invenapprTypeId,
              accId: postData.accountId,
            }
            commit('APPROVE_IVENTORY_APPROVAL_TABLE_DATA', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  rejectItemModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/reject_inventory_approval', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.invenId,
              accId: postData.accountId,
            }
            commit('APPROVE_IVENTORY_APPROVAL_TABLE_DATA', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  fetchInventoryConfigurationDetails({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {

      axios.get('/inventory/inventory_configuration/' + true)
        .then(response => {
          Nprogress.done()
          commit("SET_INVENTORY_CONFIGURATION_DATA", response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addAdminConfigureModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/add_configuration', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteAdminConfigureModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/delete_admin_configuration', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.adminId,
            }
            commit('DELETE_ADMIN_CONFIGURE_DATA', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  adminViewAllStockModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/admin_view_assignedall_stocks_settings', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  adminViewUnAssingnedStockModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/admin_view_unassigned_settings', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteAdminViewAllStockSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/delete_admin_view_assignedall_stock_settings', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.adminClassificationId,
            }
            commit('DELETE_ADMIN_CLASSIFICATION_ALL_DATA', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  deleteAdminViewUnAssignedStockSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/delete_admin_view_unassigned_settings', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.adminClassificationId,
            }
            commit('DELETE_ADMIN_CLASSIFICATION_UNASSIGNED_DATA', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  saveSubAccountPermissionInventorySettings({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/settings/save_sub_accounts_cannot_change_settings', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('SET_CHECKBOX_VALUE', postData);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  addInventoryToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory /add_assign_inventory_to_subAcc', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  inventoryConfigurationSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/inventory_configuration_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },
  fetchInventoryStockOverviewList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {

      axios.get('/inventory/stock/' + true)
        .then(response => {
          Nprogress.done()
          commit("SET_INVENTORY_STOCK_DATA", response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchInventoryStockOverviewTableList({
    commit,
    dispatch
  }, postData) {
    if (postData.load == true) {
      Nprogress.start()
    }
    return new Promise((resolve, reject) => {
      axios.post('/inventory/item_details_data', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          if (postData.load == true) {
            Nprogress.done()
          }
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit("SET_IVENTORY_STOCK_TABLE_DATA", res.data);
          }
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchInventoryItemDetail({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/get_inventory_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteStockItemModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/delete_item_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              id: postData.itemDetailsId,
            }
            commit('DELETE_STOCK_ITEM_DATA', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  deleteMultiStockItemModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/delete_multiitem_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  createStockItemModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/stock', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  importStockItemModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/import_inventory_stock_file', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importStockItemCopy({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/inventory/import_inventory_stock_file_copy', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
}

const getters = {
  getInventoryDashboardGetters: state => {
    return state.inventoryDashboardDetails;
  },
  getInventoryActivityTableGetters: state => {
    return state.inventoryActivityDetails;
  },
  InventoryItemTrackDetailsGetter: state => {
    return state.inventoryItemTrackDetails;
  },
  InventoryStockDetailsGetter: state => {
    return state.inventoryStockDetails;
  },
  InventoryStockDetailTableGetter: state => {
    return state.inventoryStockDetailsTable;
  },
  InventoryItemCategoryGetters: state => {
    return state.inventoryItemCategoryDetails;
  },
  getsampleInventoryItemSampleFilePath: state => {
    return state.itemSampleFilePath;
  },
  getsampleVendorSampleFilePath: state => {
    return state.vendorSampleFilePath;
  },
  vendorManagementListGetters: state => {
    return state.vendorManagementDetails;
  },
  vendorManagementTableGetter: state => {
    return state.vendorManagementTableDetails;
  },
  locationManagementListGetters: state => {
    return state.locationManagementDetails;
  },
  getsampleLocationSampleFilePath: state => {
    return state.locationSampleFilePath;
  },
  locationManagementTableGetter: state => {
    return state.locationManagementTableDetails;
  },
  inventoryApprovalListGetters: state => {
    return state.inventoryApprovalDetails;
  },
  inventoryApprovalTableGetter: state => {
    return state.inventoryApprovalTableDetails;
  },
  InventoryConfigurationGetters: state => {
    return state.inventoryConfigurationDetails;
  },
  InventoryStockOverviewGetter: state => {
    return state.inventoryStockOverviewDetails;
  },
  InventoryStockOverviewTableGetter: state => {
    return state.inventoryStockOverviewTableDetails;
  },
  addItemGetterstate: state => {
    return state.add_item
  },
  addVendorGetterstate: state => {
    return state.add_vendor
  },
  getsampleStockItemSampleFilePath: state => {
    return state.stockItemSampleFilePath;
  },
  socketTransferredItemsUpdate: state => {
    return state.transferredItemsPercent;
  },
  socketStockDeletedItems: state => {
    return state.deleteStockItemPercent;
  },
  socketInventoryAdd: state => {
    return state.inventoryStockAddPercent;
  },

}

export default {
  state,
  mutations,
  actions,
  getters
}
